import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import gql from 'graphql-tag'

import { useMutation } from 'components/graphql'
import { TextArea } from 'components/forms'
import { ServiceModal } from 'components/Modal'

const mutation = gql`
mutation decommissionCashRegister($id: ID!, $reason: String!) {
  cashAssist {
    decommissionCashRegister(id: $id, input: {
      outOfOrderReason: $reason,
    }) {
      id
      name
      outOfOrder
    }
  }
}
`

const DecommissionCashRegister = ({ unmount, data }) => {
	const [reason, setReason] = useState('')
	const [error, setError] = useState('')
	const [t] = useTranslation()
	const [decommisssion] = useMutation(mutation)

	const handleDecommission = () => {
		if(!reason) {
			return setError(t('validators.required'))
		}
		decommisssion({
			variables: {
				id: data.id,
				reason
			}
		})
		unmount()
	}

	return (
		<ServiceModal
			onClose={unmount}
			onOk={handleDecommission}
			width={340}
			label={t('closing_section.strings.cancel_reason')}
			keyPressActions={false}
		>
			<TextArea
				noForm
				style={{ height: '300px' }}
				value={reason}
				error={error}
				onChange={e => {
					setReason(e.target.value)
					setError()
				}}
			/>
		</ServiceModal>

	)
}

export default DecommissionCashRegister
